/**
 * ControlsSection - View component for image upload and processing controls
 * Pure presentation component that delegates all logic to ViewModel
 */

import React from 'react';
import FileInputButton from './FileInputButton';
import ProcessButton from './ProcessButton';
import MoveCounter from './MoveCounter';
import MobileInstructions from './MobileInstructions';

export default function ControlsSection({ viewModel }) {
  return (
    <>
      <div className="controls-row" style={styles.controlsRow}>
        <div style={styles.controlsLeft}>
          <FileInputButton onChange={viewModel.handleImageChange} />
          <ProcessButton
            onClick={viewModel.handleOcr}
            disabled={!viewModel.canProcessImage()}
            text={viewModel.getProcessButtonText()}
          />
        </div>
        <MoveCounter count={viewModel.getMoveCount()} />
      </div>
      <MobileInstructions />
    </>
  );
}

const styles = {
  controlsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12
  },
  controlsLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  }
};
